import { render, staticRenderFns } from "./DaysLeft.vue?vue&type=template&id=b5b5c002&scoped=true"
import script from "./DaysLeft.vue?vue&type=script&lang=js"
export * from "./DaysLeft.vue?vue&type=script&lang=js"
import style0 from "./DaysLeft.vue?vue&type=style&index=0&id=b5b5c002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b5c002",
  null
  
)

export default component.exports